 <template>
	<div class="window">
        <div class="header"><span v-html="translation.przekaz_kod_gry"></span>
            <a class="description" @click="openDescription"><information-circle-icon class="icon"/></a>
            <a class="settings" @click="openSettings"><cog-6-tooth-icon class="icon"/></a>
        </div>
        <div class="description-box">
            <div class="help-box mt2x">
                <div class="help-text" v-html="translation.help6">
                </div>
            </div>
            <div class="qrcode-bg">
                <qrcode-svg :value="gameHash" level="H" :size="200" />
            </div>
            <div class="help-box mt2x">
                <div class="help-text">{{ translation.przekaz_kod_gry_drugi_gracz }}
                </div>
                <div class="help-text blikcode">{{  blikcode }}
                </div>
            </div>

        </div>
        <a class="back-screen" @click="doNowejGry"><chevron-left-icon class="icon" /><span v-html="translation.back"></span></a>
    </div>
</template>
<script>
/*
https://www.npmjs.com/package/qrcode.vue
*/
import de from '../locale/de.js';
import en from '../locale/en.js';
import es from '../locale/es.js';
import fr from '../locale/fr.js';
import it from '../locale/it.js';
import pl from '../locale/pl.js';
import pt from '../locale/pt.js';
import { Cog6ToothIcon, InformationCircleIcon, ChevronLeftIcon } from '@heroicons/vue/24/solid';
import QrcodeSvg from 'qrcode.vue'
import axios from 'axios'

export default {
    name: 'QRScreen',
    props: {
        language: String,
        hash: String
    },
    components: { 
        Cog6ToothIcon,
        InformationCircleIcon, 
        QrcodeSvg,
        ChevronLeftIcon
    },
    data() {
        return {
            lang: localStorage.getItem('language'),
            translation: pl,
            blikcode: sessionStorage.getItem('blik'),
            theme: localStorage.getItem('theme'),
            gameHash: this.hash
        }
    },
    mounted() {
        console.log(this.hash);
        this.checkOpponent()
    },
    beforeMount() {
        switch(localStorage.getItem('language'))
        {
            case 'de':
                this.translation = de;
                break;
            case 'en':
                this.translation = en;
                break;
            case 'es':
                this.translation = es;
                break;
            case 'fr':
                this.translation = fr;
                break;
            case 'it':
                this.translation = it;
                break;
            case 'pt':
                this.translation = pt;
                break;
            default:
                this.translation = pl;
                break;
        }
    },
    methods: {
        async checkOpponent() {
            try {
                var data = new FormData();
                data.append('method', 'check-opponent');
                data.append('hash', this.hash);

                await axios.post('https://gra.wrealizacji.pl/api3.php', data)
                .then((res) => {
                    if (res.data.type == 'success') {
                        localStorage.setItem('game-hash-confirmed', localStorage.getItem('game-settings-hash'));

                        this.$emit('go-to-poziomy');
                    } else {
                        setTimeout(function() {
                            this.checkOpponent();
                        }.bind(this), 1000);
                    }
                })
                .catch((error) => {
                    console.log(error);
                        setTimeout(function() {
                            this.checkOpponent();
                        }.bind(this), 1000);
                });
            } catch (err) {
                console.log(err);
                        setTimeout(function() {
                            this.checkOpponent();
                        }.bind(this), 1000);
            }
        },
        goNext() {
            this.$emit('go-next-event');
        },
        openSettings() {
            this.$emit('open-settings');
        },
        openDescription() {
            this.$emit('open-description');
        },
        doNowejGry() {
            this.$emit('go-nowa-gra');
        },
    },
    watch: {
        language(l) {
            this.lang = l;
            switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }

        }
    },
}
</script>

<style scoped>
a.back-screen {
    position:fixed;
    left:10px;
    bottom:10px;
    color: var(--bs-button-text);
}
a.back-screen svg {
    width: 15px;
    margin-top:5px;
    position:absolute;
}
a.back-screen span {
    padding-left: 20px;
}
.blikcode {
    letter-spacing:2px;
    font-weight:bold;
    font-size:1.2em;
    margin-top:1em;
}
.qrcode-bg {
    background-color:white;
    border-radius:8px;
    margin-top:0.5em;
    padding: 1em;
}
a.back-screen {
    position:fixed;
    left:10px;
    bottom:10px;
}
a.back-screen svg {
    width: 15px;
    margin-top:5px;
}
.header {
    font-weight:bold;
    border-bottom: 1px solid var(--bs-gradient-to);
    -webkit-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    -moz-box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    box-shadow: 0px 0px 10px 0px rgba(243, 40, 120, 1);
    color: white;
    height:50px;
    display: block;
    line-height: 50px;
    position:fixed;
    top:0;
    left:0;
    right:0;
    text-align:left;
    padding: 0 20px;
    background-color: var(--bs-gradient-to);
}

a.settings svg {
    width: 25px;
    position:absolute;
    right: 20px;
    top:12px;
}

a.description svg {
    width: 25px;
    position:absolute;
    right: 60px;
    top:12px;
}
.description-box {
    padding: 0 20px;
    background-color:var(--bs-button-background);
    color: var(--bs-button-text);
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 60px;
    overflow: auto;
}

.btn.btn-all {
    font-size: 1em;
    height: 3em;
    width: 80%;
    border-radius: 10px;
    margin: 5px auto;
    font-weight:bold;
    position: relative;
}
button.btn {
    font-size: 1em;
    font-family: 'Jost', sans-serif;
}
.btn-green {
    background-color: var(--bs-gradient-to);
    color: var(--bs-pink-button-color);
    position: relative;
    border-color:white;
    border: 0 none;
}
.btn-green::after {
    content: '';
    position: absolute;
    right: 20px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-right: 2px solid var(--bs-pink-button-color);
    border-bottom: 2px solid var(--bs-pink-button-color);
    transform: translateY(-50%) rotate(-45deg);
    animation: chevronPulse 1s infinite;
    transition: transform 0.3s ease;
}

@keyframes chevronPulse {
    0%, 100% {
        transform: translateY(-50%) rotate(-45deg) translateX(0);
        opacity: 1;
    }
    50% {
        transform: translateY(-3px) rotate(-45deg) translateX(5px);
        opacity: 0.5;
    }
}

.podpowiedz {
    background-color: #e0e0e0;
    padding: 15px;
    border: 1px solid #999;
    border-radius: 15px;
    margin-bottom: 2em;
    font-size: 1.2em;
    text-align: center;
        margin-left: 30px;
    margin-right: 30px;
}
.dark .podpowiedz {
    background-color: #333;
    /* padding: 15px; */
    border: 1px solid #999;
    /* border-radius: 15px; */
    /* margin-bottom: 2em; */
    /* font-size: 1.2em; */
    /* text-align: center; */
    color: white;
}
.mt2x {
    margin-top: 2em;
}


body.dark div.grey-box {
    /* margin: 1em 0.5em; */
    background-color: #444;
    /* padding: 1em; */
    /* border-radius: 10px; */
}

div.grey-box {
    margin: 1em 0.5em;
    background-color: #eaeaea;
    padding: 1em;
    border-radius: 10px;
    overflow: auto;
}

.input-group {
    display: block;
    margin-bottom: 1em;
}
.input-group label {
    display: block;
}
body.dark .input-group input[type='text'] {
    border-top: 0 none;
    border-left: 0 none;
    border-right: 0 none;
    border-bottom: 1px solid #4e4b66;
    background-color: rgb(59, 59, 59);
    /* padding: 10px; */
    /* font-size: 20px; */
    color: white;
    /* width: calc(100% - 25px); */
    /* display: block; */
}

.input-group input[type='text'] {
    border-top: 1px solid #d0d0d0;
    border-left: 1px solid #d0d0d0;
    border-right: 1px solid #d0d0d0;
    border-bottom: 1px solid #4e4b66;
    padding: 10px;
    background-color: white;
    font-size: 20px;
    color: black;
    width: calc(100% - 25px);
    display: block;
}

#komunikat {
    text-align: center;
    color: red;
    font-weight: 500;
}

</style>
